import { Component, ViewChild, TemplateRef, Input, ElementRef, EventEmitter, Output, OnInit, OnDestroy, } from '@angular/core';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { PaginationService } from 'src/app/PaginationService';
import { messageService } from 'src/app/message.service';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { qmsService } from '../qms.service';
import { EditorConfig, ST_BUTTONS } from 'ngx-simple-text-editor';
import { SwitchuserComponent } from 'src/app/support/switchuser/switchuser.component';
import { AuService } from '../au/au.service';
import { MsalService } from '@azure/msal-angular';
import { DynamicAuditTrailComponent } from 'src/app/support/dynamic-audit-trail/dynamic-audit-trail.component';
import { ExcelPdfComponent } from 'src/app/support/excel-pdf/excel-pdf.component';
import { EditorComponent } from 'src/app/editor/editor.component';
import { GridReorderComponent } from 'src/app/grid-reorder/grid-reorder.component';

export interface PopupData {
  title: string;
}

@Component({
  selector: 'app-task-extensions',
  templateUrl: './task-extensions.component.html',
  styleUrls: ['./task-extensions.component.scss'],
})
export class TaskExtensionsComponent implements OnInit, OnDestroy {

  @Input() activityData: boolean;
  @Output() extension = new EventEmitter<{ $extension: any[], $destroying?: boolean }>();

  auditTrail: any = {};
  visibleAuditTrail: boolean = false;
  searchText: any;
  searchValue: any;
  isProcessing = false;
  _temp: any = {};
  columnLists: any = {};
  taskExtensionsDataForGrid: any = [];
  makeStickyColumns: any;
  dataTypeList: any = [];
  dateCustomClasses: DatepickerDateCustomClasses[];
  isAdenabled = localStorage.getItem('adEnabled') == 'Y';

  reviewedByTxt: any;
  approvedByTxt: any;
  userRoleTxt: any;
  userRoleSearch: any;
  anyOrAllTxt: any;
  noIfAnyTxt: any;
  extensionTypeTxt: any;
  focusmethod(value: any) {
    setTimeout(() => {
      let requiredElement = document.getElementById(value);
      requiredElement?.focus();
    }, 0);
  }

  public objectComparisonFunction = function (
    option: any,
    value: any
  ): boolean {
    return option.valueExp === value.valueExp;
  };

  actionOwners: any = [];
  loggedUserId: number;
  constructor(
    public dialog: MatDialog,
    public appService: AppService,
    public router: Router,
    private readonly snackBar: MatSnackBar,
    public paginationService: PaginationService,
    public message: messageService,
    public qualityService: qmsService,
    private readonly elem: ElementRef,
    public auService: AuService,
    private readonly authService: MsalService
  ) {
    this.isAdenabled = localStorage.getItem('adEnabled') == 'Y';

    const now = new Date();
    this.userName = localStorage.getItem('loggedUserName');
    this.loggedUserId = +this.message.getUserId();
    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];
  }

  performAction: boolean = false;
  showActionButtons: boolean = false;

  setExtensionActionButton() {

    let ccHandler: string = '';
    if (this.qualityService.moduleName == 'CC') {
      ccHandler = this.qualityService.selectedGroupDetailData.activityHandler;
    }

    const m: number[] = this.actionOwners;
    const n = +this.message.getUserId();
    const o = this.qualityService.moduleName;
    const x = (o != 'IN' && o != 'QI' && o != 'CC' && o != 'AU' && this.qualityService.activity.owner == n) || ((o == 'IN' || o == 'QI') && this.qualityService.activity.evaluator == n) || (o == 'CC' && ((ccHandler == 'Evaluator' && this.qualityService.activity.evaluator == n) || (ccHandler != 'Evaluator' && this.qualityService.activity.investigator == n)));
    const y = ['Pending Closure Review', 'Closure Review Inprogress', 'Pending Closure Approval', 'Closure Approval Inprogress'].includes(this.qualityService.activity.status);
    const z = ['In Progress', 'PhaseII In Progress', 'PhaseIII In Progress'].includes(this.qualityService.activity.status);

    this.showActionButtons = (m.includes(n) && z) || (x && (y || z));
  }

  audit() {
    if (this.qualityService.activity.status) {
      if (
        this.qualityService.moduleName == 'AU' &&
        ((this.qualityService.activity.status ==
          'Received Q&A Response' ||
          this.qualityService.activity.status ==
          'In Progress/Received Q&A Response' ||
          this.qualityService.activity.status ==
          'Pending Peer Review' ||
          this.qualityService.activity.status == 'In Progress' ||
          this.qualityService.activity.status ==
          'Peer Review Rejected' ||
          this.qualityService.activity.status ==
          'Peer Reviewer Requested More Info.' ||
          this.qualityService.activity.status ==
          'Findings In Progress' ||
          this.qualityService.activity.status ==
          'Closed/Finding In Progress' ||
          this.qualityService.activity.status ==
          'Pending Auditee Review' ||
          this.qualityService.activity.status ==
          'Auditee Requested More Info.' ||
          this.qualityService.activity.status ==
          'Auditee Accepted' ||
          this.qualityService.activity.status ==
          'Pending Closure Review' ||
          this.qualityService.activity.status ==
          'Closure Review Rejected' ||
          this.qualityService.activity.status ==
          'Closure Reviewer Requested More Info.' ||
          this.qualityService.activity.status ==
          'Pending Closure Approval' ||
          this.qualityService.activity.status ==
          'Closure Approval Rejected' ||
          this.qualityService.activity.status ==
          'Closure Approver Requested More Info.') &&
          this.auService.isAuditor) ||

        ((this.qualityService.activity.status ==
          'Findings In Progress') && this.participantsList.some((x: any) => x.applicationUserId == +this.message.getUserId()))
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  visibleDataGrid: boolean = false;
  itemsPerPage = 5; // Number of items to display per page
  currentPage = 1; // Current page number
  totalPages = 0; // Total number of pages

  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;

  showingResultsText = 'Showing results';
  displayingClaimsText = 'Displaying claims';
  rowText = 'Rows';
  showingRowsText = 'Showing rows';
  pager: any = {};
  pagedItems: any[];
  error = '';
  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(
      this.taskExtensionsDataForGrid.length,
      page,
      this.perPage,
      targetpage
    );
    this.pagedItems = this.taskExtensionsDataForGrid.slice(
      this.pager.startIndex,
      this.pager.endIndex + 1
    );
    this.isProcessing = false;
  }

  sortedColumn: string = '';
  sortedDisplayColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    this.isProcessing = true;
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortedDisplayColumn = list.fieldColumnarray;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.taskExtensionsDataForGrid.sort(
      (a: { [x: string]: any }, b: { [x: string]: any }) => {
        const key = column;
        const valueA = a[key];
        const valueB = b[key];

        if (valueA < valueB) {
          return this.sortDirection === 'asc' ? -1 : 1;
        } else if (valueA > valueB) {
          return this.sortDirection === 'asc' ? 1 : -1;
        } else {
          return 0;
        }
      }
    );
    this.setPage(1, 0);
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }
  buttonList: any;
  buttongetCall() {
    this.buttonList = [];
    let getbuttons = {
      extensionId: this.getQmsTaskExtensionsVwDetails.extensionId,
    };
    this.appService
      .getTaskExtensionButtons(getbuttons)
      .subscribe((data: any) => {

        if (data.buttonValues != null) {
          this.buttonList = data.buttonValues.split(',');
        }
        for (let k = 0; k < this.buttonList.length; k++) {
          if (this.buttonList[k] == '') {
            this.buttonList.splice(k, 1);
          }
        }
        console.log(this.buttonList);
      });
  }
  config: EditorConfig = {
    buttons: [],
  };

  @ViewChild(EditorComponent) editorComponent!: EditorComponent;
  getClobData(list: any, colunName: any) {
    this.isProcessing = true;
    let docObj = {

      primeIdentifier: list.PRIM_IDENTIFIER,
      tableView: list.tablevwname,
      columnName: colunName,
    };
    this.htmlContent = '';
    this.appService.getClobToViewAudit(docObj).subscribe({
      next: (Response: any) => {
        console.log(Response.result);
        this.htmlContent = Response.result;
        this.editorComponent.openEditor(this.htmlContent, colunName);
      }, error:
        (error) => {
          console.log(error);
        }
    });
    this.isProcessing = false;
  }
  htmlContent: any;

  getcallMethod() {
    this.isProcessing = true;
    this.taskExtensionsDataForGrid = [];
    const data = {
      gridName: 'EXTENSION',
      groupId: 0,
    };
    this.appService.getDynamicGridHeaders(data).subscribe({
      next:
        (response: any) => {

          response.orderByClause ??= '';

          this.makeStickyColumns = response.fixedFieldCnt;

          const data1: any = {
            gridName: 'QMS_TASK_EXTENSIONS_VW',
            tableOrViewName: response.tableOrViewName ?? '',
            columnsList: response.columnsList ?? '',
            fieldLabelsList: response.fieldLabelsList ?? '',
            invisibleColumn: response.invisibleColumn ?? '',
            orderByClause: response.orderByClause ?? '',
            fieldSizeList: response.fieldSizeList ?? '',
            columnsListarray: [],
            fieldColumnarray: [],
            invisibleColumnarray: [],
            fieldSizeListArray: [],
            refNoFromTaskExtensions: this.qualityService.activityId,
            manualEntryDataFields: response.manualEntryDataFields,
            clobColumnlist: response.closblist || '',
            blobColumnlist: response.bloblist || '',
          };
          this.reportObj = { ...data1, ...data };
          this.appService.getDynamicGridData(data1).subscribe({
            next:
              (response1: any) => {
                this.taskExtensionsDataForGrid = response1;
                this.labelcall();
                this.visibleAuditTrail = false;
                console.log('Data - ', this.taskExtensionsDataForGrid);
                this.extension.emit({ $extension: this.taskExtensionsDataForGrid });
                data1.columnsListarray = data1.columnsList.split(',');
                data1.fieldColumnarray = data1.fieldLabelsList.split(',');
                data1.invisibleColumnarray = data1.invisibleColumn.split(',');
                data1.fieldSizeListArray = data1.fieldSizeList.split(',');
                this.columnLists.columnsListarray = data1.columnsListarray;
                this.columnLists.fieldLabelsList = data1.fieldLabelsList;
                this.columnLists.fieldColumnarray = [];
                for (let p = 0; p < data1.fieldColumnarray.length; p++) {
                  this.columnLists.fieldColumnarray.push({
                    fieldColumnarray: data1.fieldColumnarray[p],
                    width: data1.fieldSizeListArray[p] + 'px',
                  });
                }
                this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
                this.columnLists.fieldSizeListArray = [];
                for (const element of data1.fieldSizeListArray) {
                  this.columnLists.fieldSizeListArray.push(
                    element + 'px'
                  );
                }

                for (let y = 0; y < this.columnLists.columnsListarray.length; y++) {
                  for (const element of this.columnLists.invisibleColumnarray) {
                    if (this.columnLists.columnsListarray[y] == element) {
                      this.columnLists.columnsListarray.splice(y, 1);
                      this.columnLists.fieldColumnarray.splice(y, 1);
                      this.columnLists.fieldSizeListArray.splice(y, 1);
                    }
                  }
                }

                let tableData = {
                  tablename: data1.tableOrViewName,
                };
                this.columnLists.columnsListarray1 = [];
                this.appService.tableFieldsDataType(tableData).subscribe((response2: any) => {
                  this.dataTypeList = response2;
                  for (
                    let m = 0;
                    m < this.columnLists.columnsListarray.length;
                    m++
                  ) {
                    this.columnLists.columnsListarray1.push({});
                    this.columnLists.columnsListarray1[m].columnsListarray =
                      this.columnLists.columnsListarray[m];
                    this.columnLists.columnsListarray1[m].dataType = 'textbox';
                    this.columnLists.columnsListarray1[m].width =
                      this.columnLists.fieldSizeListArray;
                    for (const element of this.dataTypeList) {
                      if (
                        element.columnName ==
                        this.columnLists.columnsListarray[m]
                      ) {
                        this.columnLists.columnsListarray1[m].dataType =
                          element.fieldType;
                      }
                    }
                  }
                  for (const element of this.taskExtensionsDataForGrid) {
                    for (const dataType of this.dataTypeList) {
                      if (dataType.fieldType == 'CHECKBOX') {
                        element[dataType.columnName] =
                          element[dataType.columnName] == 'Y';
                      }
                    }
                  }
                  this.calculateTotalPages = this.collectionSize / this.perPage;
                  this.pager.totalPages = undefined;
                  this.setPage(1, 0);
                  this.setAesthetic(this.taskExtensionsFieldData.status);
                });
                this.message.gridList = this.taskExtensionsDataForGrid;
                this.collectionSize = this.taskExtensionsDataForGrid.length;
                this.totalPages = Math.ceil(
                  this.taskExtensionsDataForGrid.length / this.itemsPerPage
                );
              }, error:
              (error) => {
                this.isProcessing = false;
                throw error;
              }
          }
          );
          this.isProcessing = false;
        }, error:
        (error) => {
          this.isProcessing = false;
          throw error;
        }
    }
    );
  }
  @ViewChild('editor', { static: true }) editor: TemplateRef<any>;
  visibleEditor: MatDialogRef<TemplateRef<any>>;

  label: any = [];
  dynamicLabel: any = null;
  editorTitle: any;
  allowEditing: boolean = false;
  editorValue: any;

  editorConfig = {
    width: '100%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  // Add button configurations for the editor
  excludeButtons: EditorConfig = {
    buttons: [],
  };

  includeButtons: EditorConfig = {
    buttons: ST_BUTTONS,
  };

  editorName: string = '';

  public openEditor(value: string, icon: string): void {

    const editorTitleMapping: Record<string, any> = {
      'Current State': this.qualityService.activityDynamicLabel?.['CURRENT_STATE']?.fieldName,
      'CAPA Description': this.qualityService.activityDynamicLabel?.['CAPA_DESCRIPTION']?.fieldName,
      'Deviation Description': this.qualityService.activityDynamicLabel?.['DEVIATION_DESCRIPTION']?.fieldName,
      'Impact Description': this.qualityService.activityDynamicLabel?.['IMPACT_DESCRIPTION']?.fieldName,
      'Complaint Description': this.qualityService.activityDynamicLabel?.['COMPLAINT_DESCRIPTION']?.fieldName,
      'Proposed Change': this.qualityService.activityDynamicLabel?.['PROPOSED_CHANGE']?.fieldName,
      'Investigation Summary': this.qualityService.activityDynamicLabel?.['INVESTIGATION_SUMMARY']?.fieldName,
      'Description': this.qualityService.activityDynamicLabel?.['DESCRIPTION']?.fieldName,
      'Initial Assessment': this.qualityService.activityDynamicLabel?.['INITIAL_ASSESSMENT']?.fieldName,
    };


    this.allowEditing = icon == 'edit';
    this.editorName = value;
    this.editorTitle = editorTitleMapping[this.editorName];
    this.editorValue = this.qualityService.activity[this.getModel(value)];
    this.visibleEditor = this.dialog.open(this.editor, this.editorConfig);
  }

  public saveEditor(editorValue: any): void {
    this.qualityService.activity[this.getModel(this.editorName)] = this.editorValue;
    this.visibleEditor.close();
  }

  private getModel(value: string): any {
    return value.split(' ')
      .map((word: string, index: number) => index === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join('');
  }

  public cancelEditor(): void {
    this.visibleEditor.close();
  };

  ctrlPressed: boolean = false;
  shiftPressed: boolean = false;
  ngOnDestroy() {
    document.removeEventListener('keydown', this.boundKeyDown);
    document.removeEventListener('keyup', this.boundKeyUp);
    window.removeEventListener('blur', this.boundReset);
    document.removeEventListener('contextmenu', this.boundReset);
    if (this.clickListener) {
      this.clickListener();
    }

    this.extension.emit({ $extension: this.taskExtensionsDataForGrid, $destroying: true });
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Control') {
      this.ctrlPressed = true;
    } else if (event.key === 'Shift') {
      this.shiftPressed = true;
    }
  }

  onKeyUp(event: KeyboardEvent) {
    if (event.key === 'Control') {
      this.ctrlPressed = false;
    } else if (event.key === 'Shift') {
      this.shiftPressed = false;
    }
  }

  resetKeyState() {
    this.ctrlPressed = false;
    this.shiftPressed = false;
  }

  onPaste(event: ClipboardEvent) {
    const isAllowedPaste = this.ctrlPressed && this.shiftPressed;
    if (!isAllowedPaste) {
      event.preventDefault();
      this.showSnackBar("You can't perform this operation. Please use Ctrl + Shift + V to paste the content", 'E');
    }
  }

  labelcall() {
    this.isProcessing = true;
    let data = {
      tableName: 'QMS_TASK_EXTENSIONS_VW',
      moduleName: null,
      gridName: 'EXTENSION',
      groupId: 0,
    };
    this.appService.getreorderGirdColumnList(data).subscribe({
      next:
        (data: any) => {
          this.label = data;
          this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
            acc[`${user.columnName}`] = user.changedFieldName;
            return acc;
          }, {});
          this.isProcessing = false;

        }, error:
        (error: any) => {
          this.isProcessing = false;
          throw error;
        }
    }
    );
  }

  dropDownDataForModule: any = [];
  listOfUsers: any = [];
  listOfReviewerUsers: any = [];
  listOfApproverUsers: any = [];
  listOfApproverUsersDropdown: any = [];
  listOfReviewerUsersDropdown: any = [];

  loopcall(a: number) {
    if (a == 2) {
      if (
        this.qualityService.activityId != null &&
        this.qualityService.activityId != ''
      ) {
        if (this.activityData) {
          this.getcallMethod();
        } else {
          this.labelcall();
          this.openEditPopup(this.message.taskLevelData);
        }
      }
    }
  }
  extensionTypeList: any = [];
  number: any = 0;
  getQmsTaskActionsVwDetails: any = [];
  taskStageUsers: any = [];
  freezeExtensionType: boolean = false;
  participantsList: any = [];
  private clickListener: () => void;
  private boundKeyDown = this.onKeyDown.bind(this);
  private boundKeyUp = this.onKeyUp.bind(this);
  private boundReset = this.resetKeyState.bind(this);
  ngOnInit() {

    document.addEventListener('keydown', this.boundKeyDown);
    document.addEventListener('keyup', this.boundKeyUp);
    window.addEventListener('blur', this.boundReset);
    document.addEventListener('contextmenu', this.boundReset);

    const statusMap: { [key: string]: string } = {
      'Pending Closure Review': 'Closure Review', 'Closure Review Inprogress': 'Closure Review', 'Pending Closure Approval': 'Closure Approve', 'Closure Approval Inprogress': 'Closure Approve'
    };

    const stageName = statusMap[this.qualityService.activity.status] || '';

    if (stageName) {
      this.appService.getTaskStageUsers(this.qualityService.activityId, 0, stageName).subscribe((stageUser: any) => {
        this.taskStageUsers = stageUser.filter((user: any) => user.status && user.status != 'Review Completed' && user.status != 'Approval Completed');
      });
    } else {
      this.taskStageUsers = [];
    }

    let ccHandler: string = '';
    if (this.qualityService.moduleName == 'CC') {
      ccHandler = this.qualityService.selectedGroupDetailData.activityHandler;
    }
    const x = this.qualityService.moduleName
    const y = this.message.getUserId();
    const z = (x != 'IN' && x != 'QI' && x != 'CC' && x != 'AU' && this.qualityService.activity.owner == y) || ((x == 'IN' || x == 'QI') && this.qualityService.activity.evaluator == y) || (x == 'CC' && ((ccHandler == 'Evaluator' && this.qualityService.activity.evaluator == y) || (ccHandler != 'Evaluator' && this.qualityService.activity.investigator == y))) || (x == 'AU' && this.auService.isAuditor);
    this.extensionTypeList = [];
    z && this.extensionTypeList.push({ displayExp: 'Overall Activity', valueExp: 'Overall Activity' });

    if (this.qualityService.moduleName == 'AU') {
      this.extensionTypeList.push({ displayExp: 'Findings', valueExp: 'Findings' });
    } else {
      this.extensionTypeList.push({ displayExp: 'Action', valueExp: 'Action' });
    }

    if (this.message.showSwitchUser) {
      this.message.showSwitchUser = true;
    } else {
      this.message.showSwitchUser = false;
    }
    this.appService
      .getQmsActiveGroupUsers(
        this.qualityService.selectedGroup,
        this.qualityService.moduleName,
        'Extension Reviewer'
      )
      .subscribe((data: any) => {
        this.listOfReviewerUsers = data;
        console.log(this.listOfReviewerUsers);
        this.listOfReviewerUsers = this.listOfReviewerUsers.sort(
          (a: any, b: any) => a.userName.localeCompare(b.userName)
        );
        this.number = this.number + 1;
        this.loopcall(this.number);
        this.callReviewerUserListSelectBoxValues();
      });
    this.appService
      .getQmsActiveGroupUsers(
        this.qualityService.selectedGroup,
        this.qualityService.moduleName,
        'Extension Approver'
      )
      .subscribe((data: any) => {
        this.listOfApproverUsers = data;
        this.listOfApproverUsers = this.listOfApproverUsers.sort(
          (a: any, b: any) => a.userName.localeCompare(b.userName)
        );
        this.number = this.number + 1;
        this.loopcall(this.number);
        this.callApproverUserListSelectBoxValues();
      });
    if (this.qualityService.moduleName == 'AU') {
      this.appService.getAllAuFindingsByAuNo(this.qualityService.activityId).subscribe((data: any) => {
        if (this.auService.isAuditor || this.auService.isAuditee) {
          this.getQmsTaskActionsVwDetails = data.filter(
            (x: any) => x.status != 'Completed' && x.status != 'Deferred' && x.status != 'Obsoleted' && x.status != 'Closed' && x.expectedClosureDate);
        } else {
          this.freezeExtensionType = true;
          this.getQmsTaskActionsVwDetails = data.filter(
            (x: any) => x.status != 'Completed' && x.status != 'Deferred' && x.status != 'Obsoleted' && x.status != 'Closed' && x.expectedClosureDate && x.assignedToUser == +this.message.getUserId());
          let findingsCount: number = 0;
          for (let x of data) {
            if (x.assignedToUser) {
              findingsCount++;
            }
          }
          findingsCount && (this.taskExtensionsFieldData.extensionType = 'Findings');
        }
        console.log(this.getQmsTaskActionsVwDetails);
        this.isProcessing = false;
        this.selectBoxForActionName();
      });


      this.appService.getAuParticipantsByAuNo(this.qualityService.activityId).subscribe((participants: any) => {
        this.participantsList = participants;
      })
    } else {
      this.appService
        .getQmsActionByRefNo(
          this.qualityService.activityId
        )
        .subscribe((data: any) => {
          this.getQmsTaskActionsVwDetails = data.filter(
            (x: any) => x.status != 'Completed' && x.status != 'Deferred' && x.status != 'Obsoleted' &&
              ((this.qualityService.activity.owner == +this.message.getUserId() || this.qualityService.activity.evaluator == +this.message.getUserId()) ||
                +this.message.getUserId() == x.assignedToUser));
          console.log(this.getQmsTaskActionsVwDetails);
          this.isProcessing = false;
          this.selectBoxForActionName();
        });
    }

    this.appService.getOneQmsUsers().subscribe((data: any) => {
      this.listOfUsers = data;
      this.selectBoxForApprovedAndReviwwdBy();
      this.isProcessing = false;
    });

    this.appService
      .getCodeListsByGroup('MODULES')
      .subscribe((data: any) => {
        this.dropDownDataForModule = data;
        this.selectBoxForModule();
        this.isProcessing = false;
      });

    if (this.qualityService.moduleName != 'OOS' && this.qualityService.moduleName != 'AU') {
      this.appService.getQmsActionByRefNo(this.qualityService.activityId).subscribe({
        next: (actions: any) => {
          this.isProcessing = false;
          for (let action of actions) {
            ['Open', 'Review Rejected', 'Approval Rejected'].includes(action.status) && this.actionOwners.push(action.assignedToUser);
          }
          this.setExtensionActionButton();
        },
        error: (err) => {
          this.isProcessing = false;
          console.error('Error:', err);
        }
      });
    } else if (this.qualityService.moduleName == 'OOS') {
      this.appService.getAllOosActionsByRefNo(this.qualityService.activity.oosNo).subscribe({
        next: (actions: any) => {
          this.isProcessing = false;
          for (let action of actions) {
            ['Open', 'Plan Review Rejected', 'Plan Approval Rejected', 'Review Rejected', 'Approval Rejected'].includes(action.status) && this.actionOwners.push(action.assignedToUser)
          }
          this.setExtensionActionButton();
        },
        error: (err) => {
          this.isProcessing = false;
          console.error('Error:', err);
        }
      });
    }
  }
  dropDownForActionName: any = [];
  actionNameListDropdown: any = [];
  selectBoxForActionName() {
    this.actionNameListDropdown = [];
    for (const element of this.getQmsTaskActionsVwDetails) {
      this.actionNameListDropdown = this.actionNameListDropdown.concat({
        valueExp:
          this.qualityService.moduleName == 'AU'
            ? element.findingId
            : element.actionId,
        displayExp:
          this.qualityService.moduleName == 'AU'
            ? element.findingShortDescription
            : element.actionName,
        targetDate:
          this.qualityService.moduleName == 'AU'
            ? element.actualClosedDate
            : element.targetDate,
        ...this.qualityService.moduleName == 'AU' && { expectedClosureDate: element.expectedClosureDate }
      });
    }
    console.log("NEW DATE", this.actionNameListDropdown);
  }
  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value
      .trim()
      .toLowerCase();

    if (filter === '') {
      this.pagedItems = this.taskExtensionsDataForGrid.slice(
        this.pager.startIndex,
        this.pager.endIndex + 1
      );
    } else {
      this.pagedItems = this.taskExtensionsDataForGrid.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)
      );
    }
  }
  callReviewerUserListSelectBoxValues() {
    this.listOfReviewerUsersDropdown = [];
    for (const element of this.listOfReviewerUsers) {
      this.listOfReviewerUsersDropdown =
        this.listOfReviewerUsersDropdown.concat({
          valueExp: element.userId,
          displayExp: element.userName,
        });
    }
  }
  callApproverUserListSelectBoxValues() {
    this.listOfApproverUsersDropdown = [];
    for (const element of this.listOfApproverUsers) {
      this.listOfApproverUsersDropdown =
        this.listOfApproverUsersDropdown.concat({
          valueExp: element.userId,
          displayExp: element.userName,
        });
    }
  }
  counts: any;
  cssfunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll(
      '.sticky-dynamic-col1'
    );
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }

      index1++;
    });

    let elements2 = this.elem.nativeElement.querySelectorAll(
      '.sticky-dynamic-row1'
    );
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    let p = 1;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          p = p + 1;
          column.style.background = 'white';
          column.style.textDecoration = 'underline';
          column.style.color = 'blue';
          column.style.cursor = 'pointer';
          if (index2 > 1) {
            colWidth += 200;
            let previousColumn = elements2[key - 1];
            console.log(previousColumn.style.width);
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
          column.addEventListener('click', this.onClick.bind(this));
        }
      }
      if (index2 == lengthOfColumns - 1) {
        index2 = 0;
      } else {
        index2++;
      }
    });
  }

  onClick(event: any) {

  }

  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;

  dataGridParentCheckBoxChecked(e: any) {
    if (e.target.checked) {
      this.childCheckBoxs = true;
      for (const element of this.taskExtensionsDataForGrid) {
        element.childCheckBoxs = true;
      }
    } else {
      this.childCheckBoxs = false;
      for (const element of this.taskExtensionsDataForGrid) {
        element.childCheckBoxs = false;
      }
    }
  }

  priviousSelectedValue: any;
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      if (this.priviousSelectedValue != undefined) {
        this.taskExtensionsDataForGrid[
          this.priviousSelectedValue
        ].childCheckBoxs = false;
      }
      this.auditTrail.refNo = list.EXTENSION_ID;
      list.childCheckBoxs = true;
    } else {
      list.childCheckBoxs = false;
    }
    this.visibleAuditTrail = this.taskExtensionsDataForGrid.some(
      (list: any) => list.childCheckBoxs
    );
    this.priviousSelectedValue = idx;
  }

  isActiveToggerBoxValue: boolean;
  isActiverFunction(isTagged: boolean) {
    this.isActiveToggerBoxValue = isTagged;
  }

  taskExtensionsFieldData: any = {};
  operationFlag: any;
  popupDataTitle: PopupData = {
    title: '',
  };

  popupTitle: string | null = 'title';
  @ViewChild('addAndEditPopup', { static: true })
  addAndEditPopup: TemplateRef<any>;
  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;
  @ViewChild('updateMessagePopup', { static: true })
  updateMessagePopup: TemplateRef<any>;

  visibleAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;
  visibleUpdateMessagePopup: MatDialogRef<TemplateRef<any>>;

  addAndEditPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  deletePopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  updateMessagePopupConfig = {
    width: '400px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };
  dateFormat: any = this.appService.organizationDetails?.dateFormat ?? 'DD-MMM-YYYY';
  datePickerConfiguration = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    adaptivePosition: true,
  };
  ClosureDatePickerConfiguration = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    minDate: new Date(),
    adaptivePosition: true,
  };
  $exceedClosureDateConfiguration() {
    const isFindingsOrAction =
      this.taskExtensionsFieldData?.extensionType === 'Findings' ||
      this.taskExtensionsFieldData?.extensionType === 'Action';

    let minDate: Date;
    let maxDate: Date | undefined;

    if (this.taskExtensionsFieldData?.extensionType === 'Findings') {
      minDate = this.findingExpectedClosureDate
        ? (() => {
          const date = new Date(this.findingExpectedClosureDate);
          date.setDate(date.getDate() + 1);
          return date;
        })()
        : new Date();
    } else if (this.taskExtensionsFieldData?.extensionType === 'Action') {
      minDate = new Date();

    } else {
      const expectedClosureDate = new Date(
        this.qualityService.activity.expcetedClosureOn
      );
      const today = new Date();

      minDate =
        expectedClosureDate > today
          ? new Date(
            expectedClosureDate.setDate(expectedClosureDate.getDate() + 1)
          )
          : new Date(today.setDate(today.getDate() + 1));
    }

    if (this.taskExtensionsFieldData?.extensionType === 'Action') {
      maxDate = new Date(this.qualityService.activity.expcetedClosureOn)
    } else {
      maxDate = undefined;
    }

    return {
      ...this.ClosureDatePickerConfiguration,
      minDate,
      maxDate,
    };
  }

  refreshGridData() {
    this.isProcessing = true;
    this.getcallMethod();
  }

  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
    closeDropDownOnSelection: true,
  };

  selectedModule: any = [];
  selectedModuleDisplayExp: any = [];
  selectedModuleValueExp: any = [];
  moduleListDropdown: any = [];
  selectBoxForModule() {
    for (const element of this.dropDownDataForModule) {
      this.moduleListDropdown = this.moduleListDropdown.concat({
        valueExp: element.codelistCode,
        displayExp: element.codelistName,
      });
    }
  }

  onModuleSelect(item: any) {

    if (item.valueExp) {
      this.selectedModuleValueExp = item.valueExp;
    } else {
      this.selectedModuleValueExp = item;
    }
  }

  onModuleRemoved(item: any) { }

  selectedApprovedByDisplayExp: any = [];
  selectedApprovedByValueExp: any = [];
  approvedByListDropdown: any = [];

  selectedReviewedByDisplayExp: any = [];
  selectedReviewedByValueExp: any = [];
  reviewedByListDropdown: any = [];

  selectBoxForApprovedAndReviwwdBy() {
    for (const element of this.listOfUsers) {
      this.approvedByListDropdown = this.approvedByListDropdown.concat({
        valueExp: element.userId,
        displayExp: element.userName,
      });

      this.reviewedByListDropdown = this.reviewedByListDropdown.concat({
        valueExp: element.userId,
        displayExp: element.userName,
      });
    }
  }

  onApprovedBySelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        if (this.approvedByFieldValue != undefined) {
          this.approvedByFieldValue.style.color = '#005c8a';
        }
      }
    }
  }

  onApprovedByRemoved(item: any) { }

  onReviewedSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        if (this.reviewedByFieldValue != undefined) {
          this.reviewedByFieldValue.style.color = '#005c8a';
        }
      }
    }
  }

  onReviewedRemoved(item: any) { }

  visibleAddButton: boolean;
  visibleEditButton: boolean;
  visibleReasonForUpdateField: boolean;
  extnType(item: any) {
    if (item.valueExp == 'Overall Activity') {
      if (
        this.qualityService.activity.expcetedClosureOn != null &&
        this.qualityService.activity.expcetedClosureOn != undefined
      ) {
        this.taskExtensionsFieldData.currentDueDate = new Date(
          this.qualityService.activity.expcetedClosureOn
        );
      } else {
        this.taskExtensionsFieldData.currentDueDate = null;
      }
    } else {
      this.taskExtensionsFieldData.actionId = null;
    }
    this.taskExtensionsFieldData.extensionRequiredTill = null;
  }

  findingExpectedClosureDate: any = null;
  actiondetailchange(item: any) {
    if (item) {
      if (this.qualityService.moduleName == 'AU') {
        this.findingExpectedClosureDate = item.expectedClosureDate ?? null;
        this.findingExpectedClosureDate && (this.taskExtensionsFieldData.currentDueDate = new Date(this.findingExpectedClosureDate));
      } else if (this.qualityService.moduleName != 'AU') {
        this.taskExtensionsFieldData.currentDueDate =
          item.targetDate ? new Date(item.targetDate) : null;
      }
    } else {
      this.findingExpectedClosureDate = this.taskExtensionsFieldData.currentDueDate = null;
    }
  }
  openAddPopup() {
    this.buttonList = [];
    this.visibleAddButton = true;
    this.visibleEditButton = false;
    this.visibleReasonForUpdateField = false;
    this.selectedModule = [];
    this.qualityService.selectedExtensionApprove = null;
    this.qualityService.selectedExtensionReview = null;

    if (
      this.qualityService.activity.expcetedClosureOn != null &&
      this.qualityService.activity.expcetedClosureOn != undefined
    ) {
      this.taskExtensionsFieldData.currentDueDate = new Date(
        this.qualityService.activity.expcetedClosureOn
      );
    } else {
      this.taskExtensionsFieldData.currentDueDate = null;
    }
    this.taskExtensionsFieldData.extensionRequiredTill = null;
    this.taskExtensionsFieldData.approvedOn = null;
    this.taskExtensionsFieldData.reviewedOn = null;
    this.taskExtensionsFieldData.approveRequestedOn = null;
    this.taskExtensionsFieldData.reviewRequestedOn = null;
    this.taskExtensionsFieldData.status = undefined;
    this.taskExtensionsFieldData.approverComments = undefined;
    this.taskExtensionsFieldData.reviewComments = undefined;
    this.taskExtensionsFieldData.justification = '';
    this.taskExtensionsFieldData.extensionType = null;
    this.taskExtensionsFieldData.actionId = null;
    this.taskExtensionsFieldData.actionDetails = null;
    this.operationFlag = 'ADD';
    this.isFrozen = false;
    this.popupDataTitle.title = 'Create Task Extensions';
    this.visibleAddAndEditPopup = this.dialog.open(
      this.addAndEditPopup,
      this.addAndEditPopupConfig
    );
  }

  previousRefNo: any;
  previousExtensionId: any;
  getQmsTaskExtensionsVwDetails: any = [];
  filteredModuleValue: any;
  filteredApprovedAtValue: any;
  filteredRequestedAtValue: any;
  isExtensionReviewOdd: any = null;
  isExtensionApproveOdd: any = null;
  openEditPopup(editRowData: any) {
    this.extensionTypeList.slice
    this.isProcessing = true;
    this.visibleAddButton = false;
    this.visibleEditButton = true;
    this.operationFlag = 'EDIT';
    this.popupDataTitle.title = 'Update Task Extensions';
    this.previousRefNo = editRowData.REF_NO;
    this.previousExtensionId = editRowData.EXTENSION_ID;
    this.filteredApprovedAtValue = [];
    this.filteredRequestedAtValue = [];
    this.filteredModuleValue = [];
    this.appService
      .getQmsTaskExtensionsVwDetailByExtensionId(
        editRowData.EXTENSION_ID
      )
      .subscribe((response: any) => {
        this.getQmsTaskExtensionsVwDetails = response;
        this.buttongetCall();
        if (response.module) {
          this.filteredModuleValue = this.dropDownDataForModule.filter(
            (x: any) => x.codelistCode === response.module
          );
          if (this.filteredModuleValue.length > 0) {
            this.selectedModule = [
              {
                valueExp: this.filteredModuleValue[0].codelistCode,
                displayExp: this.filteredModuleValue[0].codelistName,
              },
            ];
          }
        } else {
          this.selectedModule = [];
        }

        if (response.approvedBy) {
          let filteredapprovedByValue = this.listOfApproverUsersDropdown.find(
            (x: any) => x.valueExp === response.approvedBy
          );
          this.qualityService.selectedExtensionApprove = response.approvedBy;
          if (filteredapprovedByValue) {
            this.isExtensionApproveOdd = null;
          } else {
            this.isExtensionApproveOdd = response.approvedBy;
            this.listOfApproverUsersDropdown.push({
              valueExp: response.approvedBy,
              displayExp: response.approver,
            });
          }
        } else {
          this.qualityService.selectedExtensionApprove = null;
        }

        if (response.reviewedBy) {
          this.qualityService.selectedExtensionReview = response.reviewedBy;
          let filteredreviewedByValue = this.listOfReviewerUsersDropdown.find(
            (x: any) => x.valueExp === response.reviewedBy
          );
          if (filteredreviewedByValue) {
            this.isExtensionReviewOdd = null;
          } else {
            this.isExtensionReviewOdd = response.reviewedBy;
            this.listOfReviewerUsersDropdown.push({
              valueExp: response.reviewedBy,
              displayExp: response.reviewer,
            });
          }
        } else {
          this.qualityService.selectedExtensionReview = null;
        }

        if (response.currentDueDate) {
          this.taskExtensionsFieldData.currentDueDate = new Date(
            response.currentDueDate
          );
        } else {
          this.taskExtensionsFieldData.currentDueDate = null;
        }

        if (response.extensionRequiredTill) {
          this.taskExtensionsFieldData.extensionRequiredTill = new Date(
            response.extensionRequiredTill
          );
        } else {
          this.taskExtensionsFieldData.extensionRequiredTill = null;
        }

        if (response.approvedOn) {
          this.taskExtensionsFieldData.approvedOn = new Date(
            response.approvedOn
          );
        } else {
          this.taskExtensionsFieldData.approvedOn = null;
        }

        if (response.reviewedOn) {
          this.taskExtensionsFieldData.reviewedOn = new Date(
            response.reviewedOn
          );
        } else {
          this.taskExtensionsFieldData.reviewedOn = null;
        }

        if (response.approveRequestedOn) {
          this.taskExtensionsFieldData.approveRequestedOn = new Date(
            response.approveRequestedOn
          );
        } else {
          this.taskExtensionsFieldData.approveRequestedOn = null;
        }

        if (response.reviewRequestedOn) {
          this.taskExtensionsFieldData.reviewRequestedOn = new Date(
            response.reviewRequestedOn
          );
        } else {
          this.taskExtensionsFieldData.reviewRequestedOn = null;
        }

        this.taskExtensionsFieldData.status = response.status;
        this.taskExtensionsFieldData.justification = response.justification;
        this.taskExtensionsFieldData.approverComments =
          response.approverComments;
        this.taskExtensionsFieldData.reviewComments = response.reviewComments;
        this.taskExtensionsFieldData.extensionType = response.extensionType;
        this.taskExtensionsFieldData.actionId = response.actionId;
        this.taskExtensionsFieldData.actionDetails = response.actionDetails;
        this.setAesthetic(this.taskExtensionsFieldData.status);
        this.isProcessing = false;
        this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
      });
  }

  isFrozen: boolean = false;
  setAesthetic(status: string) {

    const setA = this.qualityService.moduleName == 'CR' || this.qualityService.moduleName == 'CAPA' || this.qualityService.moduleName == 'DV' || this.qualityService.moduleName == 'OOS';
    const setB = this.qualityService.moduleName == 'IN' || this.qualityService.moduleName == 'QI' || this.qualityService.moduleName == 'CC';
    const setC = this.qualityService.moduleName == 'AU';
    const userId = +this.message.getUserId();
    const user = this.qualityService.activity;

    const isValidUser =
      (setA && userId == user.owner) ||
      (setB && userId == user.evaluator) ||
      (setC && (this.auService.isAuditor || this.participantsList.some((x: any) => x.applicationUserId == +this.message.getUserId())));

    if (isValidUser && (status === "Open" || status === "Review Rejected" || status === "Approval Rejected")) {
      this.isFrozen = false;
    } else {
      this.isFrozen = true;
    }

    let ccHandler: string = '';
    if (this.qualityService.moduleName == 'CC') {
      ccHandler = this.qualityService.selectedGroupDetailData.activityHandler;
    }
    const x = this.qualityService.moduleName
    const y = this.message.getUserId();
    const z = (x != 'IN' && x != 'QI' && x != 'CC' && x != 'AU' && this.qualityService.activity.owner == y) || ((x == 'IN' || x == 'QI') && this.qualityService.activity.evaluator == y) || (x == 'CC' && ((ccHandler == 'Evaluator' && this.qualityService.activity.evaluator == y) || (ccHandler != 'Evaluator' && this.qualityService.activity.investigator == y))) || (x == 'AU' && this.auService.isAuditor);
    !z && (this.extensionTypeList = this.extensionTypeList.filter((item: any) => item.valueExp !== 'Overall Activity'));

    let isOverAllPresent: boolean = false;
    isOverAllPresent = this.extensionTypeList?.some((item: any) => item.valueExp == 'Overall Activity');
    this.taskExtensionsFieldData.extensionType == 'Overall Activity' && !isOverAllPresent && this.extensionTypeList.push({ displayExp: 'Overall Activity', valueExp: 'Overall Activity' });
  }

  idCall(editRowData: any) {
    this.appService
      .getQmsTaskExtensionsVwDetailByExtensionId(
        editRowData.EXTENSION_ID
      )
      .subscribe((response: any) => {
        this.getQmsTaskExtensionsVwDetails = response;
        this.buttongetCall();
        if (response.module) {
          this.filteredModuleValue = this.dropDownDataForModule.filter(
            (x: any) => x.codelistCode === response.module
          );
          this.selectedModule = [
            {
              valueExp: this.filteredModuleValue[0].codelistCode,
              displayExp: this.filteredModuleValue[0].codelistName,
            },
          ];
        } else {
          this.selectedModule = [];
        }

        if (response.approvedBy) {
          this.filteredApprovedAtValue = this.listOfUsers.filter(
            (x: any) => x.userId === response.approvedBy
          );
          this.qualityService.selectedExtensionApprove = this.filteredApprovedAtValue[0].userId;

        } else {
          this.qualityService.selectedExtensionApprove = [];
        }

        if (response.reviewedBy) {
          this.filteredRequestedAtValue = this.listOfUsers.filter((x: any) => x.userId === response.reviewedBy
          );
          this.qualityService.selectedExtensionReview = this.filteredRequestedAtValue[0].userId;
        } else {
          this.qualityService.selectedExtensionReview = null;
        }

        if (response.currentDueDate) {
          this.taskExtensionsFieldData.currentDueDate = new Date(
            response.currentDueDate
          );
        } else {
          this.taskExtensionsFieldData.currentDueDate = null;
        }

        if (response.extensionRequiredTill) {
          this.taskExtensionsFieldData.extensionRequiredTill = new Date(
            response.extensionRequiredTill
          );
        } else {
          this.taskExtensionsFieldData.extensionRequiredTill = null;
        }

        if (response.approvedOn) {
          this.taskExtensionsFieldData.approvedOn = new Date(
            response.approvedOn
          );
        } else {
          this.taskExtensionsFieldData.approvedOn = null;
        }

        if (response.reviewedOn) {
          this.taskExtensionsFieldData.reviewedOn = new Date(
            response.reviewedOn
          );
        } else {
          this.taskExtensionsFieldData.reviewedOn = null;
        }

        if (response.approveRequestedOn) {
          this.taskExtensionsFieldData.approveRequestedOn = new Date(
            response.approveRequestedOn
          );
        } else {
          this.taskExtensionsFieldData.approveRequestedOn = null;
        }

        if (response.reviewRequestedOn) {
          this.taskExtensionsFieldData.reviewRequestedOn = new Date(
            response.reviewRequestedOn
          );
        } else {
          this.taskExtensionsFieldData.reviewRequestedOn = null;
        }

        this.taskExtensionsFieldData.status = response.status;
        this.taskExtensionsFieldData.justification = response.justification;
        this.taskExtensionsFieldData.approverComments =
          response.approverComments;
        this.taskExtensionsFieldData.reviewComments = response.reviewComments;
        this.setAesthetic(this.taskExtensionsFieldData.statu);
        this.isProcessing = false;
      });
  }

  radioChange(event: any) {
    console.log(event.value);
    if (this.buttonLabelFieldValue != undefined) {
      this.buttonLabelFieldValue.style.color = '#005c8a';
    }
  }

  currentDueFieldValue: any;
  extensionRequiredTillFieldValue: any;
  approvedByFieldValue: any;
  reviewedByFieldValue: any;
  justificationFieldValue: any;
  actionDetailsFieldValue: any;
  extensionValue: any;

  fieldValidation() {
    this.currentDueFieldValue = document.getElementById(
      'currentDue-validation'
    ) as HTMLInputElement;
    this.extensionRequiredTillFieldValue = document.getElementById(
      'extensionRequiredTill-validation'
    ) as HTMLInputElement;
    this.approvedByFieldValue = document.getElementById(
      'approvedBy-validation'
    ) as HTMLInputElement;
    this.reviewedByFieldValue = document.getElementById(
      'reviewedBy-validation'
    ) as HTMLInputElement;
    this.justificationFieldValue = document.getElementById(
      'justification-validation'
    ) as HTMLInputElement;
    this.actionDetailsFieldValue = document.getElementById(
      'actionDetails-validation'
    ) as HTMLInputElement;
    this.extensionValue = document.getElementById('extension-validation') as HTMLInputElement;

    if (this.taskExtensionsFieldData.extensionType) {
      this.extensionValue.style.color = '#005c8a';
    } else {
      this.extensionValue.style.color = 'red';
    }

    if (this.taskExtensionsFieldData.extensionType?.toLowerCase().includes('individual')) {
      if (this.taskExtensionsFieldData.actionId) {
        this.actionDetailsFieldValue.style.color = '#005c8a';
      } else {
        this.actionDetailsFieldValue.style.color = 'red';
      }
    }

    if (this.taskExtensionsFieldData.currentDueDate == null) {
      this.currentDueFieldValue.style.color = 'red';
    } else {
      this.currentDueFieldValue.style.color = '#005c8a';
    }

    if (this.taskExtensionsFieldData.extensionRequiredTill == null) {
      this.extensionRequiredTillFieldValue.style.color = 'red';
    } else {
      this.extensionRequiredTillFieldValue.style.color = '#005c8a';
    }

    if (this.qualityService.selectedExtensionApprove == null) {
      this.approvedByFieldValue.style.color = 'red';
    } else {
      this.approvedByFieldValue.style.color = '#005c8a';
    }

    if (this.qualityService.selectedExtensionReview == null) {
      this.reviewedByFieldValue.style.color = 'red';
    } else {
      this.reviewedByFieldValue.style.color = '#005c8a';
    }

    if (
      this.taskExtensionsFieldData.justification == undefined ||
      this.taskExtensionsFieldData.justification == ''
    ) {
      this.justificationFieldValue.style.color = 'red';
    } else {
      this.justificationFieldValue.style.color = '#005c8a';
    }
  }

  currentDueDateOnChange(items: any) {
    if (items != null || items != undefined) {
      this.currentDueFieldValue.style.color = '#005c8a';
    } else {
      this.currentDueFieldValue.style.color = 'red';
    }
  }

  actionIdOnChange(items: any) {
    if (items != null || items != undefined) {
      this.actionDetailsFieldValue.style.color = '#005c8a';
    } else {
      this.actionDetailsFieldValue.style.color = 'red';
    }
  }
  extensionRequiredTillOnChange(items: any) {
    if (items != null || items != undefined) {
      this.extensionRequiredTillFieldValue.style.color = '#005c8a';
    } else {
      this.extensionRequiredTillFieldValue.style.color = 'red';
    }
  }

  onFieldFocusout() {
    if (this.justificationFieldValue != undefined) {
      if (
        this.taskExtensionsFieldData.justification == '' ||
        this.taskExtensionsFieldData.justification == undefined
      ) {
        this.justificationFieldValue.style.color = 'red';
      } else {
        this.justificationFieldValue.style.color = '#005c8a';
      }
    }
    if (this.deleteReasonFieldValue != undefined) {
      if (
        this.taskExtensionsFieldData.deleteReason == '' ||
        this.taskExtensionsFieldData.deleteReason == undefined
      ) {
        this.deleteReasonFieldValue.style.color = 'red';
      } else {
        this.deleteReasonFieldValue.style.color = '#005c8a';
      }
    }
  }

  addAndEditFunction(taskExtensionsFieldData: any) {
    if (
      this.qualityService.selectedExtensionApprove == null ||
      this.qualityService.selectedExtensionReview == null ||
      taskExtensionsFieldData.currentDueDate == null ||
      taskExtensionsFieldData.extensionRequiredTill == null ||
      taskExtensionsFieldData.justification == '' ||
      !taskExtensionsFieldData.extensionType ||
      ((taskExtensionsFieldData.extensionType == 'Findings' ||
        taskExtensionsFieldData.extensionType == 'Action') &&
        !taskExtensionsFieldData.actionId)
    ) {
      this.fieldValidation();
      this.showSnackBar('Please enter all mandatory fields', 'E');
    } else if (this.operationFlag == 'ADD') {
      this.isProcessing = true;

      if (this.qualityService.selectedExtensionApprove) {
        taskExtensionsFieldData.approvedBy =
          this.qualityService.selectedExtensionApprove;
      } else {
        taskExtensionsFieldData.approvedBy = null;
      }

      if (this.qualityService.selectedExtensionReview) {
        taskExtensionsFieldData.reviewedBy =
          this.qualityService.selectedExtensionReview;
      } else {
        taskExtensionsFieldData.reviewedBy = null;
      }

      if (this.taskExtensionsFieldData.currentDueDate) {
        this.taskExtensionsFieldData.currentDueDate = new Date(
          this.taskExtensionsFieldData.currentDueDate
        );
      } else {
        this.taskExtensionsFieldData.currentDueDate = null;
      }

      if (this.taskExtensionsFieldData.extensionRequiredTill) {
        const extensionReqTillDate = new Date(
          this.taskExtensionsFieldData.extensionRequiredTill
        );
        this.taskExtensionsFieldData.extensionRequiredTill =
          this.appService.dateZoneConvertion(extensionReqTillDate);
      } else {
        this.taskExtensionsFieldData.extensionRequiredTill = null;
      }

      if (this.taskExtensionsFieldData.approvedOn) {
        this.taskExtensionsFieldData.approvedOn = new Date(
          this.taskExtensionsFieldData.approvedOn
        );
      } else {
        this.taskExtensionsFieldData.approvedOn = null;
      }

      if (this.taskExtensionsFieldData.reviewedOn) {
        this.taskExtensionsFieldData.reviewedOn = new Date(
          this.taskExtensionsFieldData.reviewedOn
        );
      } else {
        this.taskExtensionsFieldData.reviewedOn = null;
      }

      if (this.taskExtensionsFieldData.approveRequestedOn) {
        this.taskExtensionsFieldData.approveRequestedOn = new Date(
          this.taskExtensionsFieldData.approveRequestedOn
        );
      } else {
        this.taskExtensionsFieldData.approveRequestedOn = null;
      }

      if (this.taskExtensionsFieldData.reviewRequestedOn) {
        this.taskExtensionsFieldData.reviewRequestedOn = new Date(
          this.taskExtensionsFieldData.reviewRequestedOn
        );
      } else {
        this.taskExtensionsFieldData.reviewRequestedOn = null;
      }

      let data = {
        refNo: this.message.activityId,
        module: this.qualityService.moduleName,
        currentDueDate: this.taskExtensionsFieldData.currentDueDate,
        extensionRequiredTill: this.taskExtensionsFieldData.extensionRequiredTill,
        justification: this.taskExtensionsFieldData.justification,
        approveRequestedOn: this.taskExtensionsFieldData.approveRequestedOn,
        status: this.taskExtensionsFieldData.status,
        approvedOn: this.taskExtensionsFieldData.approvedOn,
        approvedBy: this.taskExtensionsFieldData.approvedBy,
        approverComments: this.taskExtensionsFieldData.approverComments,
        reviewRequestedOn: this.taskExtensionsFieldData.reviewRequestedOn,
        reviewedBy: this.taskExtensionsFieldData.reviewedBy,
        reviewedOn: this.taskExtensionsFieldData.reviewedOn,
        reviewComments: this.taskExtensionsFieldData.reviewComments,
        extensionType: this.taskExtensionsFieldData.extensionType,
        actionId: this.taskExtensionsFieldData.actionId,
      };

      this.appService.createQmsTaskExtensions(data).subscribe({
        next:
          (Response: any) => {
            if (Response.resultType == 'S') {
              this.getcallMethod();
              this.isProcessing = true;
              this.visibleAddButton = false;
              this.visibleEditButton = true;
              this.operationFlag = 'EDIT';
              this.popupDataTitle.title = 'Update Task Extensions';
              this.previousRefNo = this.qualityService.activityId;
              this.previousExtensionId = Response.extensionId;
              this.filteredApprovedAtValue = [];
              this.filteredRequestedAtValue = [];
              this.appService
                .getQmsTaskExtensionsVwDetailByExtensionId(
                  Response.extensionId,
                )
                .subscribe((response: any) => {
                  this.getQmsTaskExtensionsVwDetails = response;
                  this.buttongetCall();
                  if (response.module) {
                    this.filteredModuleValue =
                      this.dropDownDataForModule.filter(
                        (x: any) => x.codelistCode === response.module
                      );
                    this.selectedModule = [
                      {
                        valueExp: this.filteredModuleValue[0].codelistCode,
                        displayExp: this.filteredModuleValue[0].codelistName,
                      },
                    ];
                  } else {
                    this.selectedModule = [];
                  }

                  if (response.approvedBy) {
                    this.filteredApprovedAtValue = this.listOfUsers.filter(
                      (x: any) => x.userId === response.approvedBy
                    );
                    if (this.filteredApprovedAtValue.length > 0) {
                      this.qualityService.selectedExtensionApprove =
                        this.filteredApprovedAtValue[0].userId;
                    }
                  } else {
                    this.qualityService.selectedExtensionApprove = [];
                  }

                  if (response.reviewedBy) {
                    this.filteredRequestedAtValue = this.listOfUsers.filter(
                      (x: any) => x.userId === response.reviewedBy
                    );
                    if (this.filteredRequestedAtValue.length > 0) {
                      this.qualityService.selectedExtensionReview =
                        this.filteredRequestedAtValue[0].userId;
                    }
                  } else {
                    this.qualityService.selectedExtensionReview = [];
                  }

                  if (response.currentDueDate) {
                    this.taskExtensionsFieldData.currentDueDate = new Date(
                      response.currentDueDate
                    );
                  } else {
                    this.taskExtensionsFieldData.currentDueDate = null;
                  }

                  if (response.extensionRequiredTill) {
                    this.taskExtensionsFieldData.extensionRequiredTill = new Date(
                      response.extensionRequiredTill
                    );
                  } else {
                    this.taskExtensionsFieldData.extensionRequiredTill = null;
                  }

                  if (response.approvedOn) {
                    this.taskExtensionsFieldData.approvedOn = new Date(
                      response.approvedOn
                    );
                  } else {
                    this.taskExtensionsFieldData.approvedOn = null;
                  }

                  if (response.reviewedOn) {
                    this.taskExtensionsFieldData.reviewedOn = new Date(
                      response.reviewedOn
                    );
                  } else {
                    this.taskExtensionsFieldData.reviewedOn = null;
                  }

                  if (response.approveRequestedOn) {
                    this.taskExtensionsFieldData.approveRequestedOn = new Date(
                      response.approveRequestedOn
                    );
                  } else {
                    this.taskExtensionsFieldData.approveRequestedOn = null;
                  }

                  if (response.reviewRequestedOn) {
                    this.taskExtensionsFieldData.reviewRequestedOn = new Date(
                      response.reviewRequestedOn
                    );
                  } else {
                    this.taskExtensionsFieldData.reviewRequestedOn = null;
                  }

                  this.taskExtensionsFieldData.status = response.status;
                  this.taskExtensionsFieldData.justification =
                    response.justification;
                  this.taskExtensionsFieldData.approverComments =
                    response.approverComments;
                  this.taskExtensionsFieldData.reviewComments =
                    response.reviewComments;
                  this.isProcessing = false;
                });

              this.isProcessing = false;
            }
            let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              //duration: 5000,
              data: {
                message: Response.result,
                type: Response.resultType == 'S' ? 'Success' : 'Error',
                buttonLabel: 'Ok',
                pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel,
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
            });
            sb.onAction().subscribe(() => {
              sb.dismiss();
            });
            this.isProcessing = false;
          }, error:
          (error) => {
            this.isProcessing = false;
            throw error;
          }
      }
      );
    } else {
      this.isProcessing = true;
      delete taskExtensionsFieldData.createdOn;
      delete taskExtensionsFieldData.updatedOn;

      if (this.qualityService.selectedExtensionApprove) {
        taskExtensionsFieldData.approvedBy =
          this.qualityService.selectedExtensionApprove;
      } else {
        taskExtensionsFieldData.approvedBy = null;
      }

      if (this.qualityService.selectedExtensionReview) {
        taskExtensionsFieldData.reviewedBy =
          this.qualityService.selectedExtensionReview;
      } else {
        taskExtensionsFieldData.reviewedBy = null;
      }

      if (this.taskExtensionsFieldData.currentDueDate) {
        this.taskExtensionsFieldData.currentDueDate = new Date(
          this.taskExtensionsFieldData.currentDueDate
        );
      } else {
        this.taskExtensionsFieldData.currentDueDate = null;
      }

      if (this.taskExtensionsFieldData.extensionRequiredTill) {
        const extensionReqTillDate = new Date(
          this.taskExtensionsFieldData.extensionRequiredTill
        );
        this.taskExtensionsFieldData.extensionRequiredTill =
          this.appService.dateZoneConvertion(extensionReqTillDate);
      } else {
        this.taskExtensionsFieldData.extensionRequiredTill = null;
      }

      if (this.taskExtensionsFieldData.approvedOn) {
        this.taskExtensionsFieldData.approvedOn = new Date(
          this.taskExtensionsFieldData.approvedOn
        );
      } else {
        this.taskExtensionsFieldData.approvedOn = null;
      }

      if (this.taskExtensionsFieldData.reviewedOn) {
        this.taskExtensionsFieldData.reviewedOn = new Date(
          this.taskExtensionsFieldData.reviewedOn
        );
      } else {
        this.taskExtensionsFieldData.reviewedOn = null;
      }

      if (this.taskExtensionsFieldData.approveRequestedOn) {
        this.taskExtensionsFieldData.approveRequestedOn = new Date(
          this.taskExtensionsFieldData.approveRequestedOn
        );
      } else {
        this.taskExtensionsFieldData.approveRequestedOn = null;
      }

      if (this.taskExtensionsFieldData.reviewRequestedOn) {
        this.taskExtensionsFieldData.reviewRequestedOn = new Date(
          this.taskExtensionsFieldData.reviewRequestedOn
        );
      } else {
        this.taskExtensionsFieldData.reviewRequestedOn = null;
      }

      let updateData = {
        extensionId: this.previousExtensionId,
        refNo: this.message.activityId,
        module: this.qualityService.moduleName,
        currentDueDate: this.taskExtensionsFieldData.currentDueDate,
        extensionRequiredTill:
          this.taskExtensionsFieldData.extensionRequiredTill,
        justification: this.taskExtensionsFieldData.justification,
        approveRequestedOn: this.taskExtensionsFieldData.approveRequestedOn,
        status: this.taskExtensionsFieldData.status,
        approvedOn: this.taskExtensionsFieldData.approvedOn,
        approvedBy: this.taskExtensionsFieldData.approvedBy,
        approverComments: this.taskExtensionsFieldData.approverComments,
        reviewRequestedOn: this.taskExtensionsFieldData.reviewRequestedOn,
        reviewedBy: this.taskExtensionsFieldData.reviewedBy,
        reviewedOn: this.taskExtensionsFieldData.reviewedOn,
        reviewComments: this.taskExtensionsFieldData.reviewComments,
        extensionType: this.taskExtensionsFieldData.extensionType,
        actionId: this.taskExtensionsFieldData.actionId,
      };

      this.appService.updateQmsTaskExtensions(updateData).subscribe({
        next:
          (Response: any) => {
            if (Response.resultType == 'S') {
              this.buttongetCall();
              this.getcallMethod();
              this.isProcessing = false;
            }
            let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              //duration: 5000,
              data: {
                message: Response.result,
                type: Response.resultType == 'S' ? 'Success' : 'Error',
                buttonLabel: 'Ok',
                pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel,
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
            });
            sb.onAction().subscribe(() => {
              sb.dismiss();
            });
            this.isProcessing = false;
          }, error: (error) => {
            this.isProcessing = false;
            throw error;
          }
      }
      );
    }
  }

  cancelAddAndEditFunction() {
    this.visibleAddAndEditPopup.close();
  }

  deleteReasonFieldValue: any;
  deleteValidation() {
    this.deleteReasonFieldValue = document.getElementById(
      'deleteReason-validation'
    ) as HTMLInputElement;
    if (this.deleteFiledValue.value == '') {
      this.isProcessing = false;
      this.deleteReasonFieldValue.style.color = 'red';
    } else {
      this.deleteReasonFieldValue.style.color = '#005c8a';
    }
  }

  deleteTaskExtensionsRefId: any;
  deleteTaskExtensionsExtensionId: any;
  openDeletePopup(deleteRowData: any) {
    console.log(deleteRowData);
    this.operationFlag = 'DELETE';
    this.popupDataTitle.title = 'Delete Task Extensions';
    this.deleteTaskExtensionsRefId = deleteRowData.REF_NO;
    this.deleteTaskExtensionsExtensionId = deleteRowData.EXTENSION_ID;
    if (this.taskExtensionsFieldData.deleteReason != undefined) {
      this.taskExtensionsFieldData.deleteReason = '';
    }
    this.visibleDeletePopup = this.dialog.open(
      this.deletePopup,
      this.deletePopupConfig
    );
  }

  deleteFiledValue: any;
  deleteFunction(taskExtensionsFieldData: any) {
    this.isProcessing = true;
    this.deleteFiledValue = document.getElementById(
      'deleteTextarea'
    ) as HTMLInputElement;
    if (this.deleteFiledValue.value == '') {
      this.deleteValidation();
      alert('Please enter the mandatory fields...');
      this.isProcessing = false;
    } else {
      taskExtensionsFieldData.refNo = this.message.activityId;
      taskExtensionsFieldData.extensionId =
        this.deleteTaskExtensionsExtensionId;
      taskExtensionsFieldData.deleteReason =
        this.taskExtensionsFieldData.deleteReason;
      this.appService
        .deleteQmsTaskExtensions(taskExtensionsFieldData)
        .subscribe({
          next:
            (Response: any) => {
              if (Response.resultType == 'S') {
                this.visibleDeletePopup.close();
                this.getcallMethod();
                this.isProcessing = false;
              }
              let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
                duration: 5000,
                data: {
                  message: Response.result,
                  type: Response.resultType == 'S' ? 'Success' : 'Error',
                  buttonLabel: 'Ok',
                  pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel,
                },
                horizontalPosition: 'center',
                verticalPosition: 'top',
                panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
              });
              sb.onAction().subscribe(() => {
                sb.dismiss();
              });
              this.isProcessing = false;
            }, error:
            (error) => {
              this.isProcessing = false;
              throw error;
            }
        }
        );
    }
  }

  cancelDeleteFunction() {
    this.visibleDeletePopup.close();
  }

  visibleConfirmWithReason: MatDialogRef<TemplateRef<any>>;
  isEsignRequired: boolean;
  isReasonSignReqd: boolean;
  buttonLabel: any;
  reason: any;
  userName: any;
  password: any = '';
  QAapprovedByListDropdown: any = [];
  selectedQAApprovedBy: any = [];
  confirmWithReasonPopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };
  reviewStatus: any = [];
  selectedStatus: any = null;
  @ViewChild('confirmWithReasonPopup', { static: true })
  confirmWithReasonPopup: TemplateRef<any>;
  dynamicButtonClick(ecData: any, button: any) {
    if (button == 'Save') {
      this.addAndEditFunction(this.taskExtensionsFieldData);
    } else {
      (button == 'Submit' || button == 'Re-Submit') && this.addAndEditFunction(this.taskExtensionsFieldData);
      if (button == 'Review') {
        this.reviewStatus = ['Reviewed', 'Review Rejected'];
      } else if (button == 'Approve') {
        this.reviewStatus = ['Approved', 'Approval Rejected'];
      }
      this.selectedStatus = null;
      this.reason = '';
      this.password = '';

      this.buttonLabel = button;
      this.isEsignRequired = false;
      this.isReasonSignReqd = true;
      this.isEsignRequired = true;
      this.changetypeAddAndEditPassword = true;
      this.visibleConfirmWithReason = this.dialog.open(
        this.confirmWithReasonPopup,
        this.confirmWithReasonPopupConfig
      );
    }
  }
  deleteReasonValidation() {
    const reason = document.getElementById('reason') as HTMLInputElement;
    const reasonValidationIcon = document.getElementById(
      'reason-val-icon'
    ) as HTMLInputElement;
    const reasonRequiredMsg = document.getElementById(
      'reason-required-msg'
    ) as HTMLInputElement;

    if (this.reason == '' || this.reason == null || this.reason == undefined) {
      reasonValidationIcon.innerHTML =
        '<i class="fas fa-exclamation-circle"></i>';
      reasonValidationIcon.style.color = 'red';
      reason.style.border = '1px solid red';
      reasonRequiredMsg.style.display = 'block';
    } else {
      reasonValidationIcon.innerHTML = '';
      reasonValidationIcon.style.color = 'none';
      reason.style.border = 'none';
      reasonRequiredMsg.style.display = 'none';
    }
  }

  buttonLabelFieldValue: any;
  passwordFieldValue: any;
  reasonFieldValue: any;
  dynamicFieldValidation() {
    this.passwordFieldValue = document.getElementById(
      'password-validation'
    ) as HTMLInputElement;
    this.reasonFieldValue = document.getElementById(
      'reason-validation'
    ) as HTMLInputElement;
    this.buttonLabelFieldValue = document.getElementById(
      'buttonLabel-validation'
    ) as HTMLInputElement;

    if (this.buttonLabel == 'Review' || this.buttonLabel === 'Approve') {
      if (this.selectedStatus) {
        this.buttonLabelFieldValue.style.color = '#005c8a';
      } else {
        this.buttonLabelFieldValue.style.color = 'red';
      }
    }

    if (this.password == '') {
      this.passwordFieldValue.style.color = 'red';
    } else {
      this.passwordFieldValue.style.color = '#005c8a';
    }

    if (this.reason == '' || this.reason == null) {
      this.reasonFieldValue.style.color = 'red';
    } else {
      this.reasonFieldValue.style.color = '#005c8a';
    }
  }

  onPasswordFieldFocusout() {
    if (this.passwordFieldValue != undefined) {
      if (
        this.password == '' ||
        this.password == undefined ||
        this.password == null
      ) {
        this.passwordFieldValue.style.color = 'red';
      } else {
        this.passwordFieldValue.style.color = '#005c8a';
      }
    }
  }

  reviewAndApproveExtension() {
    let selectedStatus;
    if (this.buttonLabel == 'Review' || this.buttonLabel == 'Approve') {
      selectedStatus = this.selectedStatus;
    } else {
      selectedStatus = this.buttonLabel;
    }
    this.isProcessing = true;
    if (
      this.reason == null &&
      (this.buttonLabel == 'Approve' || this.buttonLabel == 'Review')
    ) {
      this.deleteReasonValidation();
      this.isProcessing = false;
    } else if (
      this.buttonLabel == 'Submit' ||
      this.buttonLabel == 'Re-Submit'
    ) {
      let data = {
        extensionId: this.getQmsTaskExtensionsVwDetails.extensionId,
        refNo: this.message.activityId,
        module: this.qualityService.moduleName,
        approvedBy: null,
      };
      if (this.approvedByListDropdown.length > 0) {
        data.approvedBy = this.approvedByListDropdown[0].valueExp;
      }
      this.appService
        .submitActivityExtensions(data)
        .subscribe((Response: any) => {
          this.isProcessing = false;
          if (Response.resultType == 'S') {
            this.visibleConfirmWithReason.close();
            this.buttongetCall();
            this.getcallMethod();
            let editdata = {
              REF_NO: this.message.activityId,
              EXTENSION_ID: this.getQmsTaskExtensionsVwDetails.extensionId,
            };
            this.idCall(editdata);
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            //duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: 'Ok',
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
        });
    } else if (this.buttonLabel == 'Review') {
      let data = {
        extensionId: this.getQmsTaskExtensionsVwDetails.extensionId,
        refNo: this.message.activityId,
        module: this.qualityService.moduleName,
        status: selectedStatus,
        reviewComments: this.reason,
      };

      this.appService
        .reviewActivityExtensions(data)
        .subscribe((Response: any) => {
          this.isProcessing = false;
          if (Response.resultType == 'S') {
            this.visibleConfirmWithReason.close();
            this.buttongetCall();
            this.getcallMethod();
            let editdata = {
              REF_NO: this.message.activityId,
              EXTENSION_ID: this.getQmsTaskExtensionsVwDetails.extensionId,
            };
            this.idCall(editdata);
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            //duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: 'Ok',
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
        });
    } else if (this.buttonLabel == 'Approve') {
      let data = {
        extensionId: this.getQmsTaskExtensionsVwDetails.extensionId,
        refNo: this.message.activityId,
        module: this.qualityService.moduleName,
        status: selectedStatus,
        approverComments: this.reason,
      };
      if (this.buttonLabel == 'Approve') {
        this.appService
          .approveActivityExtensions(data)
          .subscribe((Response: any) => {
            this.isProcessing = false;
            if (Response.resultType == 'S') {
              this.visibleConfirmWithReason.close();
              this.buttongetCall();
              this.getcallMethod();
              let editdata = {
                REF_NO: this.message.activityId,
                EXTENSION_ID: this.getQmsTaskExtensionsVwDetails.extensionId,
              };
              this.idCall(editdata);
            }
            let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              //duration: 5000,
              data: {
                message: Response.result,
                type: Response.resultType == 'S' ? 'Success' : 'Error',
                buttonLabel: 'Ok',
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
            });
            sb.onAction().subscribe(() => {
              sb.dismiss();
            });
            this.isProcessing = false;
          });
      }
    } else {
      this.isProcessing = false;
      this.taskExtensionsFieldData.status = this.buttonLabel;
      this.addAndEditFunction(this.taskExtensionsFieldData);
    }
  }

  authEnable(flag: string) {
    this.authService
      .loginPopup({
        scopes: ['User.Read'],
        prompt: 'login',
      })
      .subscribe({
        next: (result) => {
          console.log(result.account?.username);
          let oldlooginuser = localStorage
            .getItem('loggedUserName')
            ?.toUpperCase();
          let newuser = result.account?.username.toUpperCase();
          if (oldlooginuser === newuser) {
            console.log('inside');

            this.reviewAndApproveExtension();
          } else {
            console.log('outside');
          }
        },
        error: (error) => {
          this.isProcessing = false;
          console.log(error);
        },
      });
  }
  confirmWithReasonFunc() {
    if (
      ((this.buttonLabel == 'Approve' || this.buttonLabel == 'Review') &&
        !this.selectedStatus) ||
      ((this.buttonLabel == 'Approve' ||
        this.buttonLabel == 'Review' ||
        this.buttonLabel == 'Submit' ||
        this.buttonLabel == 'Re-Submit') &&
        !this.reason) || ((this.password == '' || this.password == null) &&
          localStorage.getItem('adEnabled') != 'Y')
    ) {
      this.dynamicFieldValidation();
      alert('Please enter Mandatory Fields');
      this.isProcessing = false;
    } else if (localStorage.getItem('adEnabled') == 'Y') {
      this.authEnable('adEnabled');
    } else {
      let data = {
        userName: this.userName,
        password: this.password,
      };
      this.isProcessing = true;
      this.appService.validateUser(data).subscribe((data: any) => {
        if (data.resultType == 'S') {
          this.reviewAndApproveExtension();
        } else {
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            data: {
              message: data.result,
              type: data.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: 'Ok',
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: data.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
        }
      });
    }
  }
  cancelFunc() {
    this.visibleConfirmWithReason.close();
  }

  @ViewChild(SwitchuserComponent) switchuserComponent!: SwitchuserComponent;
  openswitchuser(value: any) {
    this.message.switchedUser = [];
    this.message.switchUserdropDownList = [];
    this.message.submodule = 'Extension';
    this.message.switchuserRole = value;
    if (value == 'Extension Reviewer') {
      this.message.switchedUser = this.qualityService.selectedExtensionReview;
      this.message.switchUserCurrentValue =
        this.qualityService.selectedExtensionReview;
      this.message.switchUserdropDownList =
        this.listOfReviewerUsersDropdown.map((item: any) => ({
          valueExp: item.valueExp,
          displayExp: item.displayExp,
        })) || [];
    } else if (value == 'Extension Approver') {
      this.message.switchedUser = this.qualityService.selectedExtensionApprove;
      this.message.switchUserCurrentValue =
        this.qualityService.selectedExtensionApprove;
      this.message.switchUserdropDownList =
        this.listOfApproverUsersDropdown.map((item: any) => ({
          valueExp: item.valueExp,
          displayExp: item.displayExp,
        })) || [];
    }
    this.switchuserComponent.openswitchuser(value, 'Extension');
  }

  onChildValueEmitted() {
    if (this.message.switchuserRole == 'Extension Reviewer') {
      this.qualityService.selectedExtensionReview = this.message.switchedUser;
    } else if (this.message.switchuserRole == 'Extension Approver') {
      this.qualityService.selectedExtensionApprove = this.message.switchedUser;
    }
    this.switchuserComponent.visibleswitchUserPopup.close();
    this.switchuserComponent.visibleConfirmationPopup.close();
    this.switchuserComponent.saveMethod();
    this.addAndEditFunction(this.taskExtensionsFieldData);
  }

  idMapping: Record<string, string> = {
    CR: this?.qualityService?.activity?.crId,
    CAPA: this.qualityService.activity.capaId,
    DV: this.qualityService.activity.dvId,
    AU: this.qualityService.activity.auId,
    IN: this.qualityService.activity.inId,
    QI: this.qualityService.activity.qiId,
    CC: this.qualityService.activity.ccId,
  };

  @ViewChild(DynamicAuditTrailComponent)
  dynamicAuditTrailComponent!: DynamicAuditTrailComponent;

  openAuditTrail(viewType: any, extension: any) {
    this.auditTrail.refNo =
      viewType == 'overAll' ? null : extension.EXTENSION_ID;
    this.auditTrail.activityRefNo = this.message.activityId;
    this.auditTrail.gridName = 'EXTENSION';
    this.auditTrail.report_And_Popup_Name =
      this.qualityService.moduleName + ' Extension Audit Trail';
    this.dynamicAuditTrailComponent.triggerTrail(extension);
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};
  reportObj: any = {};

  openReport(reportType: string) {
    this.excelPdf.reportObj = { ...this.reportObj, excludeGroupId: true };
    this.excelPdf.reportType = 'Dynamic';
    this.excelPdf.reportName =
      this.qualityService.moduleName +
      ' Extensions Report [' +
      this.idMapping[this.qualityService.moduleName] +
      ']';
    this.excelPdf.dropDown = this.columnLists?.fieldColumnarray?.map(
      (item: any) => item.fieldColumnarray
    );
    this.excelPdfComponent.openReportPopup(reportType);
  }

  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() {
    this.gridReorderComponent.reordercall(
      this.reportObj.gridName,
      this.reportObj.tableOrViewName,
      null,
      0
    );
  }

  onChildValueEmit() {
    this.getcallMethod();
  }

  changetypeAddAndEditPassword: boolean = true;
  showPassword() {
    this.changetypeAddAndEditPassword = !this.changetypeAddAndEditPassword;
  }

  snackbarRef: any;
  showSnackBar(message: string, type: string) {
    this.snackbarRef = this.snackBar.openFromComponent(
      SuccessSnackbarComponent,
      {
        duration: type === 'S' ? 5000 : undefined,
        data: {
          message,
          type: type === 'S' ? 'Success' : 'Error',
          buttonLabel: 'Ok',
          pageName: this.message.breadcrumbData.thirdLevel ? this.message.breadcrumbData.thirdLevel : this.message.breadcrumbData.secondLevel,
        },
        horizontalPosition: 'center',
        verticalPosition: 'top',
        panelClass: type === 'S' ? 'Success' : 'Error',
      }
    );

    this.snackbarRef.onAction().subscribe(() => {
      this.snackbarRef.dismiss();
    });
  }

  public focusEmpty(): void { console.log(); }
}
